// extracted by mini-css-extract-plugin
export default {"slideshowContainer":"SlickCarousel_slideshowContainer__qn-p3","pictureContainer":"SlickCarousel_pictureContainer__bkMud","pic":"SlickCarousel_pic__N+kTs"};